import styled from 'styled-components';
import { F as Flex } from '../Flex/Flex-DIrgiHUL.js';

const TooltipContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-yfjbhw-0"
})(["padding-inline:", ";padding-block:", ";max-width:", ";max-height:", ";overflow:visible;"], ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.tooltip.maxWidth, ({
  theme
}) => theme.tooltip.maxHeight);
TooltipContent.displayName = 'TooltipContent';
const TooltipScrollContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-yfjbhw-1"
})(["overflow-x:auto;"]);
TooltipScrollContainer.displayName = 'TooltipScrollContainer';
const TooltipMessage = /*#__PURE__*/styled(Flex).withConfig({
  componentId: "sc-storm-ui-40025937__sc-yfjbhw-2"
})(["min-height:", ";"], ({
  theme
}) => theme.controls.height.small.default);
TooltipMessage.displayName = 'TooltipMessage';

export { TooltipScrollContainer as T, TooltipContent as a, TooltipMessage as b };
//# sourceMappingURL=Tooltip.styles-LZFNS9U9.js.map
